import { render } from "./InjectPointForm.vue?vue&type=template&id=5f60fc8d"
import script from "./InjectPointForm.vue?vue&type=script&lang=js"
export * from "./InjectPointForm.vue?vue&type=script&lang=js"

import "./InjectPointForm.vue?vue&type=style&index=0&id=5f60fc8d&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__